import { useState } from "react";
import type { ModificaAdminItem } from "../../hooks/useFase4";
import { localeCorrente, tr } from "../../i18n";

/**
 * Christian 2026-11-03: avviso ben visibile sulla formazione inserita o
 * modificata dall'admin / presidente di lega al posto della squadra —
 * chi, giorno e ora, e col tasto info l'elenco dei cambi di ogni intervento.
 */
export function AvvisoModificaAdmin({ modifiche }: { modifiche?: ModificaAdminItem[] | null }) {
  const [aperto, setAperto] = useState(false);
  if (!modifiche || modifiche.length === 0) return null;
  const ultima = modifiche[0];
  const quando = (iso: string) =>
    new Date(iso).toLocaleString(localeCorrente(), {
      weekday: "short",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

  return (
    <div className="rounded-card border-2 border-danger/60 bg-danger/10 px-3 py-2 text-xs text-left space-y-1">
      <div className="flex items-start gap-2">
        <div className="flex-1 min-w-0">
          <div className="font-bold text-danger text-sm">
            {ultima.inserita
              ? tr("⚠ Formazione inserita dall'admin")
              : tr("⚠ Formazione modificata dall'admin")}
          </div>
          <div className="text-fg break-words">
            {tr("{{v1}} · {{v2}}", { v1: ultima.admin_nome, v2: quando(ultima.created_at) })}
            {modifiche.length > 1 &&
              tr(" · {{v1}} interventi in tutto", { v1: modifiche.length })}
          </div>
        </div>
        <button
          type="button"
          onClick={() => setAperto((v) => !v)}
          className="shrink-0 rounded-full border border-danger/60 text-danger font-bold w-7 h-7 leading-none hover:bg-danger/15"
          title={tr("Cosa e' cambiato")}
          aria-expanded={aperto}
          aria-label={tr("Cosa e' cambiato")}
        >
          i
        </button>
      </div>
      {aperto && (
        <div className="space-y-2 pt-1 border-t border-danger/30">
          {modifiche.map((m, i) => (
            <div key={`${m.created_at}-${i}`}>
              <div className="font-bold text-fg">
                {m.inserita ? tr("Inserita") : tr("Modificata")} · {m.admin_nome} ·{" "}
                {quando(m.created_at)}
              </div>
              <ul className="list-disc pl-4 text-fg-muted">
                {m.cambi.map((c, j) => (
                  <li key={j} className="break-words">
                    {c}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
